export const profileAccess = {
  add: 'Ajouter un profil',
  edit: 'Modifier un profil',
  no_data_yet: "Vous n'avez pas encore de profils",
  search: 'Chercher un profil',
  name: 'Désignation',
  status: 'Statut',
  delete_warning_message: 'Êtes-vous sûr de vouloir supprimer ce profil ?',
  update: 'Modifier le profil',
};
